import { render, staticRenderFns } from "./SendConnectionRequestModal.vue?vue&type=template&id=9e2b7e4a&scoped=true"
import script from "./SendConnectionRequestModal.vue?vue&type=script&lang=js"
export * from "./SendConnectionRequestModal.vue?vue&type=script&lang=js"
import style0 from "./SendConnectionRequestModal.vue?vue&type=style&index=0&id=9e2b7e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2b7e4a",
  null
  
)

export default component.exports